<template>
  <div>
    <!-- Quito rabbey-toolbox ya que lo han modificado y esto se ha maqueado -->
    <el-row type="flex">
      <el-col :span="4">
        <el-select
          v-model="year"
          placeholder="Año"
          size="mini"
          @change="fetchReport"
        >
          <el-option
            v-for="item in years"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <RequestTypeSelector :type.sync="request_type" @change="fetchReport" />
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="createdOrClosed"
          placeholder="Fecha de creacion o cierre?"
          size="mini"
          @change="fetchReport"
        >
          <el-option :value="false" label="Fecha de creacion"></el-option>
          <el-option :value="true" label="Fecha de cierre"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <!-- TODO: Estos valores deberian venir de la api y ser componente global ? -->
        <el-select
          v-model="serviceRequestType"
          placeholder="Estado de la solicitud"
          size="mini"
          clearable
          filterable
          @change="fetchReport"
        >
          <el-option value="New" label="Nueva"></el-option>
          <el-option value="Open" label="Abierta"></el-option>
          <el-option value="Assigned" label="Asignada"></el-option>
          <el-option value="InProgress" label="En Progreso"></el-option>
          <el-option value="Closed" label="Cerrada"></el-option>
          <el-option value="Validated" label="Validada"></el-option>
          <el-option
            value="CoordinatingInstallers"
            label="Coordinando Instalacion"
          ></el-option>
          <el-option
            value="RegisteringDevices"
            label="Registrando Dispositivos"
          ></el-option>
          <el-option value="Reopened" label="Reabierta"></el-option>
          <el-option value="Cancelled" label="Cancelada"></el-option>
          <el-option
            value="RequiresContractUpdate"
            label="Requiere Actualizacion de Contrato"
          ></el-option>
          <el-option
            value="EditingRequestedDevices"
            label="Editando Dispositivos en Solicitud"
          ></el-option>
          <el-option
            value="RequiresInventoryExit"
            label="Requiere Actualizacion de Inventario"
          ></el-option>
          <el-option
            value="RequiresAccountingUpdate"
            label="Requiere Actualizacion Contable"
          ></el-option>
          <el-option value="Complete" label="Completado"></el-option>
          <el-option
            value="AgregarComentario"
            label="Añadio Comentario"
          ></el-option>
          <el-option value="ReAssigned" label="Re Asignada"></el-option>
          <el-option value="Pending" label="Sin Calificar"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="selectedTechnician"
          clearable
          size="mini"
          placeholder="Tecnico"
          filterable
          @change="handleTechnicianChange"
        >
          <el-option
            v-for="(item, index) in technicians"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="4">
        <el-select
          v-model="selectedGerencia"
          clearable
          size="mini"
          placeholder="Gerencia"
          filterable
          @change="handleGerenciaChage"
        >
          <el-option value="42" label="Tecnologia"> </el-option>

          <el-option value="41" label="Servicio al cliente"> </el-option>

          <el-option value="49" label="Operaciones y Proyectos"> </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <rabbey-table-3
          :stripe="true"
          :loading="loading"
          :data="report"
          :columns="mapColumns"
          :summary-method="getSummaries"
          show-summary
        />
      </el-col>
    </el-row>
    <rabbey-base-drawer
      :title="title"
      :drawer.sync="drawer"
      size="85%"
      :before-close="CloseDetails"
    >
      <el-row>
        <div>
          <DetailChart ref="detailChart" :DetailParams="DetailData" />
        </div>
        <el-col>
          <rabbey-table-3
            :loading="loadingDetail"
            :data="requests"
            :row-class-name="tableRowClassName"
            :columns="columnsDetails"
          />
        </el-col>
      </el-row>
    </rabbey-base-drawer>
  </div>
</template>

<script>
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import HyperLinkSellerReportTecnicalRequest from "@/components/functionals/HyperLinkSellerReportTecnicalRequest.vue";
import { MONTHS_LIST } from "@/const";
import DetailChart from "@/views/Charts/ExternalRequestChart.vue";
import RequestTypeSelector from "@/components/Company/RequestTypeSelector.vue";
import { formatArrayToElSelect } from "@/utils";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import SLAClolorStatus from "@/components/functionals/SLAClolorStatus";
import GetRate from "@/components/requests/internal/GetRate.vue";

export default {
  name: "ReportRequestByTechnical",
  components: {
    RequestTypeSelector,
    DetailChart
  },

  created() {
    this.fetchReport();
    this.getTechnicians();
  },
  data() {
    return {
      loading: false,
      loadingDetail: false,
      columns: [
        {
          prop: "TechnicalId",
          label: "No.",
          width: 90,
          sortable: true,
          fix: true
        },
        {
          prop: "TechnicalName",
          label: "Tecnico Asignado",
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "TechnicalImageUrl"
          },
          minWidth: 200,
          sortable: true,
          fix: true
        }
      ],
      columnsDetails: [
        {
          prop: "Id",
          label: "NO",
          width: 90,
          sortable: true,
          formatter: SLAClolorStatus
        },
        {
          prop: "CustomerName",
          label: "Cliente",
          minWidth: 300,
          sortable: true
        },
        {
          prop: "ServiceRequestTypeDescription",
          label: "Tipo",
          minWidth: 200,
          sortable: true
        },
        {
          prop: "StatusDescription",
          label: "Estado",
          minWidth: 100,
          sortable: true
        },
        {
          prop: "Comments",
          label: "Descripcion",
          minWidth: 400,
          sortable: true
        },
        {
          prop: "Valoracion",
          label: "Valoracion",
          minWidth: 150,
          align: "center",
          formatter: GetRate,
          sortable: true
        },
        {
          prop: "ValoracionComents",
          label: "Comentario",
          minWidth: 300,
          sortable: true
        },
        {
          prop: "Diagnostic",
          label: "Diagnóstico",
          minWidth: 300,
          sortable: true
        },
        {
          prop: "Solution",
          label: "Solución",
          minWidth: 400,
          sortable: true
        },
        {
          prop: "SLAHoursToRespond",
          label: "SLA",
          minWidth: 75,
          align: "center",
          sortable: true
        },
        {
          prop: "DaysLate",
          label: "Dias Retrasada",
          minWidth: 150,
          align: "center",
          formatter: SLAClolorStatus,
          sortable: true
        },
        {
          prop: "RequestDate",
          label: "Creado",
          formatter: DatetimeFormatter,
          minWidth: 130,
          sortable: true
        },
        {
          prop: "ServiceRequestCloseDate",
          label: "Cerrado",
          formatter: DatetimeFormatter,
          minWidth: 130,
          sortable: true
        },
        {
          prop: "DueDate",
          label: "Limite",
          formatter: DatetimeFormatter,
          minWidth: 130,
          sortable: true
        }
      ],
      report: [],
      year: new Date().getFullYear(),
      request_type: null,
      title: "",
      drawer: false,
      selectedTechnician: "",
      selectedGerencia: "",
      requests: [],
      technicians: [],
      techniciansLoading: false,
      //requestColumns: requestColumns,
      createdOrClosed: false,
      serviceRequestType: null,
      DetailData: {
        Month: 0,
        chartData: []
      }
    };
  },
  computed: {
    years() {
      const lowLevel = 2014;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (let i = lowLevel; i <= currentYear; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    },
    mapColumns() {
      let columns = this.columns;
      for (let i = 0; i < 12; i++) {
        const month = MONTHS_LIST[i];
        columns.push({
          prop: month,
          label: this.$t(`months.${month}`),
          name: this.$t(`months.${month}`),
          attrs: {
            openSelect: this.openSelect,
            getType: this.getType,
            month: i + 1
          },
          formatter: HyperLinkSellerReportTecnicalRequest
        });
      }

      columns.push({
        prop: "Totals",
        label: "Total",
        name: "Total",
        attrs: {
          isTotal: true,
          openSelect: this.openSelect,
          month: 0
        },
        formatter: HyperLinkSellerReportTecnicalRequest
      });
      return columns;
    }
  },
  methods: {
    formatArrayToElSelect,
    fetchReport() {
      this.loading = true;

      this.$http
        .get("/api/serviceRequests/GetReportByTechnical", {
          params: {
            company: this.currentCompany,
            year: this.year,
            requestType: this.request_type,
            close: this.createdOrClosed,
            status: this.serviceRequestType,
            tecnicoID: this.selectedTechnician,
            GerenciaId: this.selectedGerencia
          }
        })
        .then(({ data }) => {
          this.report = data;
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    },
    getTechnicians() {
      this.$http.get("/api/users/technicians").then((resp) => {
        this.technicians = this.formatArrayToElSelect(resp.data, {
          label: "label",
          value: "id"
        });
        this.techniciansLoading = false;
      });
    },
    handleTechnicianChange() {
      this.fetchReport();
      return this.selectedTechnician;
    },
    tableRowClassName({ row }) {
      var fecha = row.ServiceRequestCloseDate;

      if (fecha == null && row.Status != 9) {
        return "warning-row";
      }
      return "";
    },
    handleGerenciaChage() {
      this.fetchReport();
    },
    openSelect(props) {
      this.loadingDetail = true;
      this.title = `Solicitudes asignadas a ${props.row.TechnicalName}`;
      this.drawer = true;
      this.DetailData = {
        Month: props.month
      };
      this.$http
        .get("/api/serviceRequests/GetReportByTechnicalDetail", {
          timeout: 3000 * 6 * 1000,
          params: {
            company: this.currentCompany,
            year: this.year,
            technical: props.row.TechnicalId,
            month: props.month,
            requestType: this.request_type,
            close: this.createdOrClosed,
            status: this.serviceRequestType
          }
        })
        .then(({ data }) => {
          this.requests = data.serviceList;
          this.DetailData.chartData = data.serviceChart;
          for (this.cals in this.requests) {
            this.Status = this.requests[this.cals].Status;
          }
          this.$refs.detailChart.getChartData();
        })
        .finally(() => (this.loadingDetail = false));
    },
    CloseDetails() {
      this.drawer = false;
      this.$refs.detailChart.bar.series[0].data = [];
      this.$refs.detailChart.loading = true;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "Totales :";
        }
      });

      return sums;
    }
  }
};
</script>

<style>
.el-table .warning-row {
  /* background: #ff6666; */
  color: #ff6666;
}
</style>
